import { Box, Grid, Paper, useMediaQuery } from '@mui/material'
import React, { ReactNode } from 'react'
import { pagesPath, staticPath } from '~/lib/$path'
import { theme } from '~/lib/theme'
import { EyeCatchImage } from './EyeCatchImage'
import { useRouter } from 'next/router'
import { CornerImages } from './CornerImages'

/**
 * SigninSignupContent コンポーネントは、サインインおよびサインアップページ、パスワードリセットページ、新規会員登録ステップページのレイアウトを管理するコンポーネントです。
 *
 * このコンポーネントは、以下の要素を含んでいます：
 * - スクリーンサイズに応じて表示する CornerImages コンポーネント（画面の四隅に画像を配置します）。
 * - メインの画像（ロゴなど）を表示する EyeCatchImage コンポーネント。
 * - サインインまたはサインアップなど、フォームを含む Paper コンポーネント。
 *
 * @param {ReactNode} props.children - フォームや追加コンテンツなど、ページに表示する子要素。
 */
export const SigninSignupContent = (props: { children: ReactNode }) => {
  const router = useRouter()
  const pathname = router.pathname

  const isBreakpointUpMd = useMediaQuery(theme.breakpoints.up('md'))
  const isBreakpointDownSx = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', overflow: 'hidden' }}>
      {!isBreakpointUpMd && <CornerImages />}
      <Grid container direction="row">
        <Grid
          size={{
            md: 7,
            xs: 'auto',
          }}
        >
          <Box
            sx={{
              [theme.breakpoints.down('md')]: {
                height: 'auto',
                width: '100vw',
              },
              [theme.breakpoints.up('md')]: {
                height: '100vh',
              },
            }}
          >
            <EyeCatchImage
              imageSrc={pathname === SINGUP_PATH ? staticPath.signup_png : staticPath.signin_logo_png}
              mobileImageSrc={
                pathname === SINGUP_PATH && isBreakpointDownSx
                  ? staticPath.signup_png
                  : pathname === SINGUP_PATH
                    ? staticPath.signup_mobile_png
                    : staticPath.signin_logo_png
              }
              altText={pathname === SINGUP_PATH ? SIGNUP_ALT_TEXT : SIGNIN_ALT_TEXT}
            />
          </Box>
        </Grid>

        <Grid
          size={{
            md: 5,
            xs: 12,
          }}
        >
          <Box
            sx={{
              backgroundColor: isBreakpointUpMd ? 'whitesmoke' : 'transparent',
              [theme.breakpoints.up('md')]: {
                height: '100vh',
                overflow: 'auto',
              },
            }}
          >
            <Paper
              elevation={pathname === SINGUP_ACCOUNT_PATH ? 1 : 2}
              sx={{
                m: {
                  xs: pathname === SINGUP_ACCOUNT_PATH ? 5 : 3,
                  sm: pathname === SINGUP_ACCOUNT_PATH ? 5 : 8,
                  md: pathname === SINGUP_ACCOUNT_PATH ? 3 : 5,
                  lg: pathname === SINGUP_ACCOUNT_PATH ? 3 : 13,
                },
              }}
            >
              {props.children}
            </Paper>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

const SIGNUP_ALT_TEXT = `toridori marketing
あなたの商品・サービスをPRするしてくれるインフルエンサーを募集できるサービスです。
SNS発信のプロであるインフルエンサーの、多様な表現と、発信力をあなたのお店に。`
const SIGNIN_ALT_TEXT = `toridori marketing`
const SINGUP_PATH = pagesPath.signup.$url().pathname
const SINGUP_ACCOUNT_PATH = pagesPath.signup.account.$url().pathname
